import type { FC } from 'react'

import type { FlowDirection, TimeUnitMode } from '../calendar.types'

import Box from '../../box'
import { IconButton } from '../../button'
import { cs } from '../../utils'
import { TimeUnitHeader } from './timeUnitHeader'

type Props = {
  nextDisabled?: boolean
  onChangeViewItem: (direction: FlowDirection) => void
  onSetTimeUnitMode: (mode: TimeUnitMode) => void
  prevDisabled?: boolean
  timeUnitMode: TimeUnitMode
  viewMonth: Date
}

const size = 40

/**
 * Header for the calendar
 */
export const CalendarHeader: FC<Props> = ({
  nextDisabled,
  onChangeViewItem,
  onSetTimeUnitMode,
  prevDisabled,
  timeUnitMode,
  viewMonth,
}) => (
  <Box borderBottom="1px solid" borderColor="sandstone.main" centerV className={cs('vui-calendar-header')}>
    <Box className="vui-calendar-header-left">
      <TimeUnitHeader onSetTimeUnitMode={onSetTimeUnitMode} timeUnitMode={timeUnitMode} viewMonth={viewMonth} />
    </Box>
    <Box className="vui-calendar-header-right" flex="1" justifyContent="right">
      <IconButton
        aria-label="previous"
        className="icon"
        disabled={prevDisabled}
        h={size}
        icon="uiChevronLeft"
        onClick={() => onChangeViewItem('prev')}
        size="sm"
        variant="tertiary"
        w={size}
      />
      <IconButton
        aria-label="next"
        className="icon"
        disabled={nextDisabled}
        h={size}
        icon="uiChevronRight"
        onClick={() => onChangeViewItem('next')}
        size="sm"
        variant="tertiary"
        w={size}
      />
    </Box>
  </Box>
)
